import * as React from 'react';
import LogoColor from '../../../images/logo_white.svg';
import LogoWhite from '../../../images/logo.svg';
import { CSSProperties } from 'styled-components';

type Props = {
  color: 'default' | 'white';
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
};

export const Logo: React.VFC<Props> = (props) => {
  return props.color === 'white' ? (
    <LogoColor
      alt="Dentis（デンティス）"
      width={props.width}
      height={props.height}
    />
  ) : (
    <LogoWhite
      alt="Dentis（デンティス）"
      width={props.width}
      height={props.height}
    />
  );
};
